export function buildCloudinaryUrl(publicId, transformations) {
  const baseUrl = 'https://res.cloudinary.com/djvqy2bag/image/upload/';
  return `${baseUrl}${transformations}/${publicId}`;
}
